export default __webpack_public_path__ + "static/media/a02.c0ad51a2.jpg";